// frontend/src/pages/PlayerScoring.js
import React, { useEffect, useState } from 'react';
import api from '../api';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';

const PlayerScoring = () => {
    const [devices, setDevices] = useState([
        { id: 'device123', name: '设备A' },
        { id: 'device456', name: '设备B' },
        // ...其他设备
    ]);
    const [selectedDevice, setSelectedDevice] = useState('');
    const [points, setPoints] = useState(0);
    const [showScoringModal, setShowScoringModal] = useState(false);
    const [exceptionStatus, setExceptionStatus] = useState(false);
    const [userId, setUserId] = useState(null); // 根据您的身份验证实现方式获取

    useEffect(() => {
        // 获取当前用户信息，特别是 exceptionStatus
        const fetchUserInfo = async () => {
            try {
                const res = await api.get('/api/users/me'); // 假设有此端点返回当前用户信息
                setExceptionStatus(res.data.exceptionStatus);
                setUserId(res.data._id);
            } catch (err) {
                console.error('获取用户信息失败:', err);
                toast.error('获取用户信息失败');
            }
        };
        fetchUserInfo();
    }, []);

    const handleStartScoring = (device) => {
        setSelectedDevice(device.id);
        setPoints(0);
        setShowScoringModal(true);
    };

    const handleCloseScoringModal = () => {
        setShowScoringModal(false);
        setSelectedDevice('');
        setPoints(0);
    };

    const handleSubmitScoring = async () => {
        if (!userId) {
            toast.error('用户未登录');
            return;
        }

        if (!selectedDevice) {
            toast.warning('请选择设备');
            return;
        }

        if (points <= 0) {
            toast.warning('积分必须为正数');
            return;
        }

        try {
            const res = await api.post(`/api/users/${userId}/score-device`, {
                deviceId: selectedDevice,
                points: points,
            });
            toast.success(res.data.message);
            handleCloseScoringModal();
        } catch (err) {
            console.error('上分失败:', err);
            if (err.response && err.response.data && err.response.data.message) {
                toast.error(err.response.data.message);
            } else {
                toast.error('上分失败');
            }
        }
    };

    if (exceptionStatus) {
        return (
            <div className="container mt-5">
                <h3>上分功能已被异常状态限制</h3>
                <p>请联系管理员以解除异常状态，才能继续进行上分操作。</p>
            </div>
        );
    }

    return (
        <div className="container mt-5">
            <h3>玩家上分</h3>
            <Table bordered>
                <thead>
                    <tr>
                        <th>设备名称</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    {devices.map(device => (
                        <tr key={device.id}>
                            <td>{device.name}</td>
                            <td>
                                <Button variant="primary" size="sm" onClick={() => handleStartScoring(device)}>
                                    上分
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* 上分模态对话框 */}
            <Modal show={showScoringModal} onHide={handleCloseScoringModal}>
                <Modal.Header closeButton>
                    <Modal.Title>上分到设备</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formDevice">
                            <Form.Label>设备</Form.Label>
                            <Form.Control type="text" value={selectedDevice} disabled />
                        </Form.Group>
                        <Form.Group controlId="formPoints" className="mt-3">
                            <Form.Label>使用积分</Form.Label>
                            <Form.Control
                                type="number"
                                min="1"
                                value={points}
                                onChange={(e) => setPoints(e.target.value)}
                                placeholder="请输入使用积分"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseScoringModal}>
                        取消
                    </Button>
                    <Button variant="primary" onClick={handleSubmitScoring}>
                        确认
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default PlayerScoring;
